export const PAYMENT_STATUSES = ["Pending", "Completed"];

export const DEFAULT_PAYMENT_STATUS = "Pending";

export function normalizePaymentStatus(value) {
  if (value == null || String(value).trim() === "") return DEFAULT_PAYMENT_STATUS;
  const trimmed = String(value).trim();
  const lower = trimmed.toLowerCase();
  if (lower === "completed" || lower === "paid") return "Completed";
  if (lower === "pending") return "Pending";
  const match = PAYMENT_STATUSES.find((s) => s.toLowerCase() === lower);
  return match ?? DEFAULT_PAYMENT_STATUS;
}
